import type { OwnerListing } from "../../services/listings.service";
import {
  PAUSED_INTERNALLY_STATUS,
  PAUSED_LISTING_THUMBNAIL_PX,
} from "../constants/host-hub-paused-listings.consts";
import type { PausedListingItem } from "../types/model/paused-listing";
import { pickListingThumbnailUrl } from "./cloudinary-image.utils";

/**
 * Truncates `text` to `maxLength` characters, appending an ellipsis when it had
 * to be shortened. Trailing whitespace before the ellipsis is trimmed.
 */
export const truncateText = (text: string, maxLength: number): string =>
  text.length > maxLength ? `${text.slice(0, maxLength).trimEnd()}…` : text;

const toPausedListingItem = (listing: OwnerListing): PausedListingItem => {
  const spaceTitle = listing.title ?? "";

  return {
    id: listing._id,
    mediaAlt: spaceTitle,
    mediaUrl: pickListingThumbnailUrl({
      images: listing.images,
      size: PAUSED_LISTING_THUMBNAIL_PX,
    }),
    spaceTitle,
    useType: listing.use_type,
  };
};

/**
 * Maps the host's owner listings into per-row card items for the "paused by
 * Peerspace" top-priority card, keeping only listings with a
 * `PAUSED_INTERNALLY` status. Returns an empty array when there are none.
 */
export const toPausedListingItems = (
  listings: OwnerListing[] | undefined,
): PausedListingItem[] =>
  (listings ?? [])
    .filter((listing) => listing.status === PAUSED_INTERNALLY_STATUS)
    .map(toPausedListingItem);
